define('$console', function() {
  'use strict';
  return window.console;
});
